import { render, staticRenderFns } from "./CalendarActivityTab.vue?vue&type=template&id=3c2d2bdb&scoped=true&"
import script from "./CalendarActivityTab.vue?vue&type=script&lang=js&"
export * from "./CalendarActivityTab.vue?vue&type=script&lang=js&"
import style0 from "./CalendarActivityTab.vue?vue&type=style&index=0&id=3c2d2bdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2d2bdb",
  null
  
)

export default component.exports